import { render } from "./AreaScreenBarTable.vue?vue&type=template&id=87863c7c&scoped=true"
import script from "./AreaScreenBarTable.vue?vue&type=script&lang=js"
export * from "./AreaScreenBarTable.vue?vue&type=script&lang=js"

import "./AreaScreenBarTable.vue?vue&type=style&index=0&id=87863c7c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87863c7c"]])

export default __exports__